// extracted by mini-css-extract-plugin
module.exports = {"list":"InlineItems_list___1Esd","button":"InlineItems_button__NcR4Z","title":"InlineItems_title__5MVpd"};